module.exports = __webpack_public_path__ + "img/beer_id-54.c5e1004f.png";